import React from 'react'
import { WContainer, WImage } from 'components/atoms'
import styles from './NewsletterHero.module.sass'

interface Props {
  title?: string
  description?: string
  image?: string
  imageMobile?: string
  className?: string
}

const NewsletterHero = (props: Props) => {
  const {
    title = '',
    description = '',
    image = '',
    imageMobile = '',

    className = '',
  } = props


  return (
    <div className={`${styles.newsletterHero} ${className}`}>
      
        <div
          className={`${styles.layout}`}
        >
          <div className={styles.content}>
            {!!title && <h1 className={styles.title}>{title}</h1>}
            {!!description && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
         
            <div className={styles.imageBox}>
              <WImage
                src={image}
                alt={title}
                title={title}
                maxWidth={1080}
                maxHeight={383}
                //layout="responsive"
                objectFit="cover"
                priority
                loading="eager"
              />
            </div>
        </div>
    
    </div>
  )
}

export default NewsletterHero
